import { render, staticRenderFns } from "./page-not-found-no-options.vue?vue&type=template&id=67aa5672&scoped=true"
import script from "./page-not-found-no-options.vue?vue&type=script&lang=js"
export * from "./page-not-found-no-options.vue?vue&type=script&lang=js"
import style0 from "./page-not-found-no-options.vue?vue&type=style&index=0&id=67aa5672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa5672",
  null
  
)

export default component.exports